<res-base-modal [modalTitle]="modalTitle" [modalClass]="modalClass" [modalAutomationId]="modalAutomationId"
    (primaryButtonActionEmt)="ok()" (closeButtonActionEmt)="closeModal()" [modalHelpIndex]="modalHelpIndex"
    [isPrimaryBtnEnabled]="okEnabled()" [secondaryButtonLabel]="'Cancel'" [primaryButtonLabel]="'OK'"
    [resizeHorizontal]="true" [resizeHorizontalMin]="600" [resizeVertical]="true" [resizeVerticalMin]="400"
    [buttonTemplate]="validateButtonTemplate" [isCloseButtonDisabled]="isCloseButtonDisabled">
    <div class="grid-area">
        <res-generic-grid #systemStorageDepotGrid [gridName]="gridName" [automationId]="automationId"
            [columnDefs]="columnDefs" [pagerVisible]="false" [rowSelection]="rowSelection" [isBusy]="isBusy"
            [isBusyMessage]="isBusyMessage">
        </res-generic-grid>
    </div>
    <ng-template #validateButtonTemplate>
        <button type="button" [attr.data-automation-id]="modalAutomationId + '-validate-button'"
            class="secondary-button" (click)="validate()" [disabled]="!isValidateEnabled()">
            <i class="fa fa-check fa-icon sizing-icons"></i>Validate</button>
    </ng-template>
</res-base-modal>